// App-wide distraction-free ("focus") mode for the editor tabs. When on, the
// outer header, the workspace tab bar, and the connection sidebar are hidden
// (via a `.focus-mode` class on the root `.app`), leaving just the inner editor
// tabs maximized — with the Ninocat logo pinned beside them. Session-only: a
// module-level signal, the same pattern as the editor prefs (editorAutoFormat /
// editorLineWrap). Entered from the query / script editor toolbars; left with the
// Exit button or Escape.
import { createSignal } from 'solid-js';

export const [focusMode, setFocusMode] = createSignal(false);
export const toggleFocusMode = () => setFocusMode((v) => !v);
